<template>
	<div>
        <div class="Rectangle-12-Copy">
            <span class="Puestos t-header-green">Puestos</span>
            <span class="Cant t-header-green">Cant</span>
            <span class="Promedio t-header-green">Promedio</span>
            <span class="Redondear-Prom t-header-green">Redondear Prom.</span>
            <span class="Sueldo-Actual t-header-green">Sueldo Actual</span>
            <span class="Sueldo-Actual-Total t-header-green">Sueldo Actual Total</span>
            <span class="Sueldo-Ideal t-header-green">Sueldo Ideal</span>
        </div>
	</div>
</template>

<script>
export default {
	name: 'app-table-disenar-escala-header',
};
</script>

<style lang="scss" scoped>
    .Rectangle-12-Copy {
        width: 100%;
        max-width: 1032px;
        height: 35px;
        margin: 10px auto 8px;
        padding: 0px 0px 5px 35px;
        border-radius: 9px;
        background-color: #55ac4b;
        display: flex;
        align-items: center;
    }
    .t-header-green {
        font-size: 14px;
        font-family: NeuzeitGroTBold;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #fff;
    }
    .Puestos {
        text-align: left;
        width: 18%;
        //margin: 0 180px 0 0;
    }
    .Cant {
        width: 12%;
        //margin: 0 97px 0 180px;
    }
    .Promedio {
        width: 16.5%;
        //margin: 0 52px 0 97px;
    }
    .Redondear-Prom {
       width: 11.5%;
        //margin: 0 34px 0 52px;
    }
    .Sueldo-Actual {
        width: 14.5%;
        //margin: 0 44px 0 34px;
    }
    .Sueldo-Actual-Total {
        width: 15.5%
    }
    .Sueldo-Ideal {
        width: 12%;
        //margin: 0 0 0 38px;
    }
    span {
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/shared/table-disenar-escala/app-table-disenar-escala-header.vue